module.exports = __webpack_public_path__ + "img/set_email@2x.f801b1ea.png";